export function getContainerOffset(container) {
  const scrollWindow = container;
  const scrollWindowStyles = scrollWindow ? window.getComputedStyle(scrollWindow) : null;
  const offsetLeft = scrollWindowStyles ? parseFloat(scrollWindowStyles.marginLeft || '0') : 0;
  const offsetRight = scrollWindowStyles ? parseFloat(scrollWindowStyles.marginRight || '0') : 0;
  return {
    offsetLeft,
    offsetRight
  };
}
//# sourceMappingURL=getContainerOffset.js.map